import { render, staticRenderFns } from "./TaskBandItem.vue?vue&type=template&id=8963787a&scoped=true"
import script from "./TaskBandItem.vue?vue&type=script&lang=js"
export * from "./TaskBandItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8963787a",
  null
  
)

export default component.exports